import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock, Mail, MapPin, Phone } from "lucide-react";

const Contact = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-center mb-8">Contact Us</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <Clock className="mr-2" /> Office Hours
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p>Monday: 9:00 AM – 5:00 PM</p>
            <p>Tuesday: 9:00 AM – 5:00 PM</p>
            <p>Wednesday: 9:00 AM – 5:00 PM</p>
            <p>Thursday: Closed</p>
            <p>Friday: 9:00 AM – 5:00 PM</p>
            <p>Saturday: Closed</p>
            <p>Sunday: Closed</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <MapPin className="mr-2" /> Location
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p>Address:</p>
            <p>2116 S. Wayne Rd.</p>
            <p>Westland, MI, 48186</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <Phone className="mr-2" /> Phone
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p>Call: (734) 629-8971</p>
            <p>Fax: (734) 895-7047</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <Mail className="mr-2" /> Email
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p>apexmedical14@gmail.com</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Contact;
